import { faFileInvoice, faHeadset, faFileLines, faCloudUpload, faCog, faLocationDot, faUserShield, faTruckRampBox, faHome, faUniversalAccess, faAddressCard, faTruckFront, faUser, faBuilding, faTruckDroplet } from "@fortawesome/free-solid-svg-icons";
import { Routess } from "./routes";

export const sidebarMenu = [
    {
      title: "Dashboard",
      icon: faHome,
      link: Routess.DashboardOverview.path,
      permission: Routess.DashboardOverview.permission,
    },
    {
      title: "Bilty",
      icon: faFileInvoice,
      link: Routess.Bilty.path,
      permission: Routess.Bilty.permission,
    },
    {
      title: "Companies",
      icon: faBuilding,
      link: Routess.Company.path,
      permission: Routess.Company.permission,
    },
    {
      title: "Loads",
      icon: faTruckRampBox,
      link: Routess.Loads.path,
      permission: Routess.Loads.permission,
    },
    {
      title: "Shippers",
      icon: faAddressCard,
      link: Routess.Shipper.path,
      permission: Routess.Shipper.permission,
    },
    {
      title: "Transporters",
      icon: faAddressCard,
      link: Routess.Transporter.path,
      permission: Routess.Shipper.permission,
    },
    {
      title: "Truck Types",
      icon: faTruckFront,
      link: Routess.TruckTypes.path,
      permission: Routess.TruckTypes.permission,
    },
    {
      title: "Trucks",
      icon: faTruckFront,
      link: Routess.Truck.path,
      permission: Routess.Truck.permission,
    },
    {
      title: "KYC Documents",
      icon: faFileLines,
      link: Routess.KycDocs.path,
      permission: Routess.KycDocs.permission,
    },
    {
      title: "KYC Section Documents",
      icon: faFileLines,
      link: Routess.KycSections.path,
      permission: Routess.KycSections.permission,
    },
    {
      title: "KYC Requests",
      icon: faUserShield,
      link: Routess.Kyc.path,
      permission: Routess.Kyc.permission,
    },
    {
      title: "Truck KYC Requests",
      icon: faTruckDroplet,
      link: Routess.TruckKyc.path,
      permission: Routess.TruckKyc.permission,
    },
    {
      title: "Locations",
      icon: faLocationDot,
      link: Routess.States.path,
      permission: Routess.States.permission,
    },
    // {
    //   title: "Website",
    //   icon: faGlobe,
    //   eventKey: "websites/",
    //   permission: "CANMANAGEWEBSITE",
    //   children: [
    //     { title: "Banners", link: Routess.Banners.path, permission: Routess.Banners.permission },
    //     { title: "News & Events", link: Routess.NewsAndEvent.path, permission: Routess.NewsAndEvent.permission },
    //     { title: "Staff", link: Routess.Staff.path, permission: Routess.Staff.permission },
    //     { title: "Admission Enquiry", link: Routess.Enquiry.path, permission: Routess.Enquiry.permission },
    //     { title: "Contact Enquiry", link: Routess.ContactEnquiry.path, permission: Routess.ContactEnquiry.permission },
    //     { title: "Gallery", link: Routess.Gallery.path, permission: Routess.Gallery.permission },
    //     { title: "Social Accounts", link: Routess.SocialAccounts.path, permission: Routess.SocialAccounts.permission },
    //   ],
    // },
    { title: "File Explorer", icon: faCloudUpload, link: Routess.Cloud.path, permission: Routess.Cloud.permission },
    { title: "CRM Users", icon: faUser, link: Routess.User.path, permission: Routess.User.permission },
    { title: "User Roles", icon: faUniversalAccess, link: Routess.UserGroup.path, permission: Routess.UserGroup.permission },
    { title: "Settings", icon: faCog, link: "/", permission: null },
    { title: "Reports", icon: faFileLines, link: Routess.Reports.path, permission: Routess.Reports.permission },
    { title: "Support", icon: faHeadset, link: Routess.Support.path, permission: Routess.Support.permission },
  ];
  